// eslint-disable-next-line import/prefer-default-export
export const users = [{
  name: 'Вадим',
  phone: '81231231212',
  password: '123',
},
{
  name: 'Алексей',
  phone: '89998887766',
  password: '1234',
},
{
  name: 'Григорий',
  phone: '88887776655',
  password: '12345',
},
{
  name: 'Валерий',
  phone: '87776665544',
  password: '123456',
},
{
  name: 'Максим',
  phone: '86665554433',
  password: '1234567',
},
];
